import { makeStyles } from '@mui/styles';

export const useListPageHeaderStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.down('sm')]: {
      padding: '1.5rem 0 3rem 0'
    },
    padding: '3rem 0',
    color: '#ffffff',
    position: 'relative'
  },
  title: {
    width: 'auto',
    flexGrow: 0,
    flexShrink: 1,
    whiteSpace: 'nowrap'
  },
  subtitle: {
    color: '#ffffffc4',
    fontSize: '1.175rem',
    minHeight: '1.85rem',
    marginBottom: '5px'
  },
  filtersToggle: {
    color: 'rgba(255, 255, 255, 0.7 )',
    padding: '10px 0',
    cursor: 'pointer'
  },
  controls: {
    flexGrow: 1,
    flexShrink: 0
  }
}));
